export default __webpack_public_path__ + "static/media/oldfog3.8f5407b8.png";